import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { IMessageData } from '@app/layout/message/message.model';

@Injectable({
  providedIn: 'root'
})
export class MessageDOS {
  private _messageListSubject = new BehaviorSubject<IMessageData[]>([]);
  readonly messageList$ = this._messageListSubject.asObservable();

  getMessageListSnapshot(): IMessageData[] {
    return this._messageListSubject.value;
  }

  updateMessageList(data: IMessageData[]): void {
    this._messageListSubject.next(data);
  }
}
